module.exports = __webpack_public_path__ + "media/images/icons/flags/BS-d37046a4a0179031b7e3084a2b35cba1.svg";